import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const HealthIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 5.06749C1 2.82108 2.79086 1 5 1C6.19469 1 7.26706 1.53259 8 2.37703C8.73295 1.53259 9.80531 1 11 1C13.2091 1 15 2.82108 15 5.06749C15 5.82666 14.8439 6.59716 14.5784 7.35869H11.7112C11.4006 7.35869 11.1032 7.48594 10.8867 7.71149L9.17202 9.49764L6.99474 5.08757C6.58606 4.25977 5.43327 4.22215 4.97281 5.02158L3.62666 7.35869H1.5V7.57498C1.18705 6.74333 1 5.89862 1 5.06749Z"
		></path>
		<path
			fill="currentColor"
			d="M1.98726 8.67526C3.15904 10.9874 6.1436 13.5064 7.66045 14.8693C7.85438 15.0436 8.14562 15.0436 8.33955 14.8693C9.8564 13.5064 12.841 10.9874 14.0127 8.67526H11.7746L9.95687 10.5688C9.40495 11.1437 8.45782 10.995 8.10373 10.2778L5.956 5.92754L4.70616 8.09744C4.50007 8.45524 4.12183 8.67526 3.71281 8.67526H1.98726Z"
		></path>
	</svg>
))
